module.exports = __webpack_public_path__ + "static/media/actions.124a0ad5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/actions.jpg
// module id = 331
// module chunks = 37